import script from "./ContactBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactBanner.vue?vue&type=script&setup=true&lang=js"

import "./ContactBanner.vue?vue&type=style&index=0&id=379834ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379834ff"]])

export default __exports__